// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../img/admin_brand.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../img/admin_icon.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* #592727 RED */
/* #2f5927 GREEN */
/* #30426a BLUE (default)*/
/* Sidebar background color */
/* Sidebar header and footer color */
/* Sidebar title text colour */
/* Sidebar menu item hover color */
/**
 * Sidebar
 */
#sidebar-wrapper {
  background: #663333;
}
ul.sidebar .sidebar-main a,
.sidebar-footer,
ul.sidebar .sidebar-list a:hover,
#page-wrapper:not(.open) ul.sidebar .sidebar-title.separator {
  /* Sidebar header and footer color */
  background: #5f3030;
}
ul.sidebar {
  position: absolute;
  top: 0;
  bottom: 0;
  padding: 0;
  margin: 0;
  list-style: none;
  text-indent: 20px;
  overflow-x: hidden;
  overflow-y: auto;
}
ul.sidebar li a {
  color: #fff;
  display: block;
  float: left;
  text-decoration: none;
  width: 290px;
  cursor: pointer;
}
ul.sidebar .sidebar-main {
  height: 65px;
}
ul.sidebar .sidebar-main a {
  font-size: 18px;
  line-height: 60px;
}
ul.sidebar .sidebar-main a:hover {
  cursor: pointer;
}
ul.sidebar .sidebar-main .menu-icon {
  float: right;
  font-size: 18px;
  padding-right: 28px;
  line-height: 60px;
}
ul.sidebar .sidebar-main .menu-brand {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  display: inline-block;
  height: 20px;
  width: 150px;
  background-repeat: no-repeat;
  background-position: top left;
  margin-top: 18px;
  margin-bottom: 5px;
  background-size: 100%;
}
ul.sidebar .sidebar-main .menu-toggle-icon {
  float: right;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  display: inline-block;
  height: 36px;
  width: 36px;
  background-repeat: no-repeat;
  background-position: top left;
  margin-right: 18px;
  margin-top: 9px;
  margin-bottom: 9px;
  margin-left: 18px;
  background-size: 100%;
}
ul.sidebar .sidebar-title {
  color: #bb7777;
  font-size: 12px;
  height: 35px;
  line-height: 40px;
  text-transform: uppercase;
  transition: all 0.1s ease 0s;
}
ul.sidebar .sidebar-list {
  height: 40px;
}
ul.sidebar .sidebar-list a {
  text-indent: 25px;
  font-size: 15px;
  color: #b2bfdc;
  line-height: 40px;
}
ul.sidebar .sidebar-list a:hover {
  color: #fff;
  border-left: 3px solid #cc0000;
  text-indent: 22px;
}
ul.sidebar .sidebar-list a:hover .menu-icon {
  text-indent: 25px;
}
ul.sidebar .sidebar-list .menu-icon {
  float: right;
  padding-right: 29px;
  line-height: 40px;
  width: 70px;
}
ul.sidebar .sidebar-list.active a {
  color: #fff;
  border-left: 3px solid #cc0000;
  text-indent: 22px;
}
ul.sidebar .sidebar-list.active a .menu-icon {
  text-indent: 25px;
}
ul.sidebar .sidebar-list-level2 {
  height: 33px;
  padding-left: 13px;
}
ul.sidebar .sidebar-list-level2 a {
  text-indent: 30px;
  font-size: 12px;
  color: #b2bfdc;
  line-height: 38px;
  width: 273px;
}
ul.sidebar .sidebar-list-level2 a:hover {
  color: #fff;
  border-left: 2px solid #ff6666;
  text-indent: 28px;
}
ul.sidebar .sidebar-list-level2 a:hover .menu-icon {
  text-indent: 30px;
}
ul.sidebar .sidebar-list-level2 .menu-icon {
  float: right;
  padding-right: 29px;
  line-height: 38px;
  width: 70px;
}
ul.sidebar .sidebar-list-level2.active a {
  color: #fff;
}
#page-wrapper:not(.open) ul.sidebar {
  bottom: 0;
}
#page-wrapper:not(.open) ul.sidebar .sidebar-title {
  display: none;
  height: 0px;
  text-indent: -100px;
}
#page-wrapper:not(.open) ul.sidebar .sidebar-title.separator {
  display: block;
  height: 2px;
  margin: 13px 0;
}
#page-wrapper:not(.open) ul.sidebar .sidebar-list a:hover span {
  border-left: 3px solid #e99d1a;
  text-indent: 22px;
}
`, "",{"version":3,"sources":["webpack://./layout/resources/less/sidebar.less"],"names":[],"mappings":"AAAA,gBAAgB;AAChB,kBAAkB;AAClB,0BAA0B;AAC1B,6BAA6B;AAC7B,oCAAoC;AACpC,8BAA8B;AAC9B,kCAAkC;AAClC;;EAEE;AAJF;EACI,mBAAA;AAMJ;AAHA;;;;EAQE,oCAAoC;EAHlC,mBAAA;AAKJ;AAFA;EACI,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;AAIJ;AAbA;EAYY,WAAA;EACA,cAAA;EACA,WAAA;EACA,qBAAA;EACA,YAAA;EACA,eAAA;AAIZ;AArBA;EAqBQ,YAAA;AAGR;AAxBA;EAuBY,eAAA;EACA,iBAAA;AAIZ;AA5BA;EA2BY,eAAA;AAIZ;AA/BA;EA8BY,YAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;AAIZ;AArCA;EAoCY,yDAAA;EACA,qBAAA;EACA,YAAA;EACA,YAAA;EACA,4BAAA;EACA,6BAAA;EAEA,gBAAA;EACA,kBAAA;EAEA,qBAAA;AAEZ;AAhDA;EAiDY,YAAA;EACA,yDAAA;EACA,qBAAA;EACA,YAAA;EACA,WAAA;EACA,4BAAA;EACA,6BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,qBAAA;AAEZ;AA9DA;EAgEQ,cAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EACA,yBAAA;EACA,4BAAA;AACR;AAtEA;EAwEQ,YAAA;AACR;AAzEA;EA0EY,iBAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;AAEZ;AA/EA;EAgFY,WAAA;EACA,8BAAA;EACA,iBAAA;AAEZ;AApFA;EAoFgB,iBAAA;AAGhB;AAvFA;EAwFY,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;AAEZ;AA7FA;EAiGY,WAAA;EACA,8BAAA;EACA,iBAAA;AADZ;AAlGA;EAqGgB,iBAAA;AAAhB;AArGA;EA2GQ,YAAA;EACA,kBAAA;AAHR;AAzGA;EA8GY,iBAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,YAAA;AAFZ;AAhHA;EAqHY,WAAA;EACA,8BAAA;EACA,iBAAA;AAFZ;AArHA;EAyHgB,iBAAA;AADhB;AAxHA;EA6HY,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;AAFZ;AA9HA;EAqIY,WAAA;AAJZ;AAQA;EAEQ,SAAA;AAPR;AAKA;EAIY,aAAA;EACA,WAAA;EACA,mBAAA;AANZ;AAAA;EASY,cAAA;EACA,WAAA;EACA,cAAA;AANZ;AALA;EAgBoB,8BAAA;EACA,iBAAA;AARpB","sourcesContent":["@import \"variables.less\";\n\n/**\n * Sidebar\n */\n#sidebar-wrapper {\n    background: @sidebarBaseColor;\n}\n\nul.sidebar .sidebar-main a,\n.sidebar-footer,\nul.sidebar .sidebar-list a:hover,\n#page-wrapper:not(.open) ul.sidebar .sidebar-title.separator {\n    /* Sidebar header and footer color */\n    background: @sidebarHeaderColor;\n}\n\nul.sidebar {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    padding: 0;\n    margin: 0;\n    list-style: none;\n    text-indent: 20px;\n    overflow-x: hidden;\n    overflow-y: auto;\n    li {\n        a {\n            color: #fff;\n            display: block;\n            float: left;\n            text-decoration: none;\n            width: 290px;\n            cursor: pointer;\n        }\n    }\n    .sidebar-main {\n        height: 65px;\n        a {\n            font-size: 18px;\n            line-height: 60px;\n        }\n        a:hover {\n            cursor: pointer;\n        }\n        .menu-icon {\n            float: right;\n            font-size: 18px;\n            padding-right: 28px;\n            line-height: 60px;\n        }\n        .menu-brand {\n            background-image: url(../img/admin_brand.png);\n            display: inline-block;\n            height: 20px;\n            width: 150px;\n            background-repeat: no-repeat;\n            background-position: top left;\n            //margin-right: 18px;\n            margin-top: 18px;\n            margin-bottom: 5px;\n            //margin-left: 18px;\n            background-size:100%;\n        }\n        .menu-toggle-icon {\n            float: right;\n            background-image: url(../img/admin_icon.png);\n            display: inline-block;\n            height: 36px;\n            width: 36px;\n            background-repeat: no-repeat;\n            background-position: top left;\n            margin-right: 18px;\n            margin-top: 9px;\n            margin-bottom: 9px;\n            margin-left: 18px;\n            background-size:100%;\n        }\n    }\n    .sidebar-title {\n        color: @sidebarTitleColor;\n        font-size: 12px;\n        height: 35px;\n        line-height: 40px;\n        text-transform: uppercase;\n        transition: all .1s ease 0s;\n    }\n    .sidebar-list {\n        height: 40px;\n        a {\n            text-indent: 25px;\n            font-size: 15px;\n            color: #b2bfdc;\n            line-height: 40px;\n        }\n        a:hover {\n            color: #fff;\n            border-left: 3px solid @sidebarMenuItemHover;\n            text-indent: 22px;\n            .menu-icon {\n                text-indent: 25px;\n            }\n        }\n        .menu-icon {\n            float: right;\n            padding-right: 29px;\n            line-height: 40px;\n            width: 70px;\n        }\n    }\n\n    .sidebar-list.active {\n        a {\n            color: #fff;\n            border-left: 3px solid @sidebarMenuItemHover;\n            text-indent: 22px;\n            .menu-icon {\n                text-indent: 25px;\n            }\n        }\n    }\n\n    .sidebar-list-level2 {\n        height: 33px;\n        padding-left: 13px;\n        a {\n            text-indent: 30px;\n            font-size: 12px;\n            color: #b2bfdc;\n            line-height: 38px;\n            width: 273px;\n        }\n        a:hover {\n            color: #fff;\n            border-left: 2px solid @sidebarMenuItemLevel2Hover;\n            text-indent: 28px;\n            .menu-icon {\n                text-indent: 30px;\n            }\n        }\n        .menu-icon {\n            float: right;\n            padding-right: 29px;\n            line-height: 38px;\n            width: 70px;\n        }\n    }\n    .sidebar-list-level2.active {\n        a {\n            color: #fff;\n        }\n    }\n}\n#page-wrapper:not(.open) {\n    ul.sidebar {\n        bottom: 0;\n        .sidebar-title {\n            display: none;\n            height: 0px;\n            text-indent: -100px;\n        }\n        .sidebar-title.separator {\n            display: block;\n            height: 2px;\n            margin: 13px 0;\n        }\n        .sidebar-list {\n            a:hover {\n                span {\n                    border-left: 3px solid #e99d1a;\n                    text-indent: 22px;\n                }\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
